import cx from 'clsx';
import type React from 'react';

type Props = {
  className?: string;
  label?: string;
  labelPosition?: 'left' | 'right';
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ControlledToggle = ({ className, label, labelPosition = 'left', value, onChange }: Props) => {
  return (
    <div className={cx('relative flex w-max flex-col', className)} data-testid="control-input">
      <label className={cx('flex cursor-pointer select-none items-center gap-2', labelPosition === 'right' && 'flex-row-reverse')}>
        {label && <span className="text-grey-label">{label}</span>}
        <div className="relative">
          <input type="checkbox" checked={value} onChange={onChange} className="peer sr-only" />
          <div className="block h-8 w-14 rounded-full bg-[#E5E7EB] peer-checked:bg-sky-400" />
          <div className="dot absolute top-1 left-1 h-6 w-6 rounded-full bg-white transition peer-checked:translate-x-6" />
        </div>
      </label>
    </div>
  );
};
